/**
 * Fellowship ordering.
 *
 * Business rule: the newest fellowship by call year is "Fellowship 1" and the
 * oldest is last. Fellowships with the same call year keep their existing
 * (creation) order, and fellowships without a usable call year come last.
 *
 * The position is display only: it is the index in the sorted list and is
 * never stored. Records are always saved by id.
 */

/**
 * Extract a 4 digit call year from "2022", 2022, "2022-01-01" or an ISO
 * timestamp. Returns null when blank or not a valid year.
 */
export const callYearOf = (value) => {
  if (value === null || value === undefined || value === '') return null

  const match = String(value).trim().match(/^(\d{4})(?!\d)/)
  if (!match) return null

  const year = Number(match[1])
  return year > 0 ? year : null
}

/**
 * Return a new array sorted by call year, newest first. Stable for ties.
 * `getDate` reads the call year/date from an entry (the field name differs
 * between the API payloads and the edit forms).
 */
export const sortFellowshipsByCallYear = (
  list,
  getDate = (entry) => entry?.edctp_call_date
) => {
  if (!Array.isArray(list)) return []

  return list
    .map((entry, position) => ({ entry, position, year: callYearOf(getDate(entry)) }))
    .sort((a, b) => {
      if (a.year !== b.year) {
        if (a.year === null) return 1
        if (b.year === null) return -1
        return b.year - a.year
      }
      return a.position - b.position
    })
    .map(({ entry }) => entry)
}
